import Loader from "@amzn/meridian/esm/components/loader";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import aimsTheme from "../styles/meridian-theme-aims.json";

/**
 * Loading - horizontally centered loader with an optional label below it. Shared by every loading
 * state (route bootstrap, RTMS start/end, session tabs, transcription). The label sits below the
 * loader in normal flow so it never shifts the loader. Wraps itself in the AiMS theme so it renders
 * correctly outside a themed subtree (e.g. the route shell).
 */
const Loading = ({ label }) => (
  <Theme palette={aimsTheme}>
    <Column alignmentHorizontal="center" spacingInset="600 none none none" spacing="300">
      <Loader />
      {label && (
        <Text type="h50" color="primary">
          {label}
        </Text>
      )}
    </Column>
  </Theme>
);

export default Loading;
